import {
  Component,
  EventEmitter,
  OnInit,
  OnDestroy,
  Output,
  ElementRef,
  HostListener,
  ViewChild,
} from "@angular/core";
import { Router, ActivatedRoute, NavigationEnd } from "@angular/router";

import { APIService } from "./../api/api.service";
import { NotifierService } from "./../_services/notifier.service";

import SearchData from "../data/searchData";
import * as moment from "moment";
import { environment } from "src/environments/environment";
import { DashService } from "./dash.service";
import { LoginComponent } from "../login/login.component";
import { Subscription } from "rxjs";

declare var $: any;
declare var window: any;

// ─── Module-level exports ────────────────────────────────────────────────────

export let internetActive: boolean;

export let regions: any = {
  enabled: [],
  disabled: [],
};

export let cftrequired: any = {
  "tell-me": {
    cft: moment("09-05-2023", "DD-MM-YYYY").valueOf(),
    link: "/dash/tell-me",
  },
};

export let emsIntegration: any = [
  "/dash/reports/view?reportType=inventory",
  "/dash/site24x7/monitors",
];

export function isNhaCompany(selectedClientName?: string | null): boolean {
  const role = localStorage.getItem("role") || "";
  const company = localStorage.getItem("com") || "";
  const selectedClient =
    selectedClientName || localStorage.getItem("selectedClientName") || "";

  const isAllowedCompany = (value: string) => {
    const v = (value || "").toString().trim().toLowerCase();
    return v === "nha" || v === "cdot";
  };
  const isNhaClientUser = role === "Client" && isAllowedCompany(company);
  const isNhaAdminUser = role === "Admin" && isAllowedCompany(selectedClient);

  return isNhaClientUser || isNhaAdminUser;
}

export interface CookieOptions {
  expires?: number | Date;
  path?: string;
  domain?: string;
  secure?: boolean;
}

// ─── Domain interfaces ────────────────────────────────────────────────────────

export interface Account {
  accountId: string;
  accountName: string;
  cp: string;
  cft_status?: boolean | string;
  cft_latest_version?: number;
  cft_latest_version_raw?: string;
  cft_current_version?: number;
  cft_latest_url?: any;
  cft_deployed_region?: string;
  regions?: string[];
  customRegions?: boolean;
  customeRegions?: boolean;
  importType?: string;
  site_247_project_id?: string;
  site_247_project_name?: string;
  monitoringUrl?: string;
  jira_org_id?: string;
  jira_org_name?: string;
  jira_project_id?: string;
  jira_project_key?: string;
  jira_project_name?: string;
  cft_error_show?: boolean;
  [key: string]: any;
}

export interface Client {
  emailId: string;
  cmpName: string;
}

export interface AccountGroup {
  groupName: string;
}

export interface Region {
  id: string;
  name: string;
  status: string;
}

export interface DropdownState<T> {
  list: T[];
  selected: string;
}

export interface ValidationRule {
  router: string;
  condition: string | (() => boolean);
  title: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

@Component({
  selector: "app-dash",
  templateUrl: "./dash.component.html",
  styleUrls: ["./dash.component.css"],
})
export class DashComponent implements OnInit, OnDestroy {
  @ViewChild("rgWrapper", { static: false })
  rgWrapper!: ElementRef;

  // ── UI state ────────────────────────────────────────────────────────────────
  isSupportOpen = false;
  currentLevel: 0 | 1 | 2 | 3 = 0;
  showExpired: boolean = false;
  showcontent: boolean = false;
  isMenuCollapsed = false;
  showLegacyRequestEc2Menu: boolean = false;
  showSearchResult: boolean = false;
  mandatory: boolean = false;
  enableBU: boolean = false;
  filterText: string = "";
  showMore: boolean = false;
  started: boolean = false;
  hideAccountTab: boolean = true;
  viewNotificationTrigger = false;
  checkingCFT: boolean = false;
  currentAccountCFTStatus: boolean = null;
  width: any;
  link: string = null;

  // ── User / session ──────────────────────────────────────────────────────────
  userId = localStorage.getItem("eId");
  username = localStorage.getItem("un");
  cbsAccess: boolean = false;
  betaAccess: boolean = false;
  showITAS: boolean = false;
  /**
   * True during the initial boot sequence — prevents localStorage writes and
   * cross-component notifications until the first account is fully resolved.
   */
  isInitialLoad: boolean = true;
  masterEmailId: string = localStorage.getItem("masterId");
  subType: string = localStorage.getItem("subType") || "freetrial";
  isUserAdmin: boolean = localStorage.getItem("isUserAdmin") == "1";
  productType: string = localStorage.getItem("productType") || null;
  ut = localStorage.getItem("ut");
  urlPrefix: any = localStorage.getItem("role") == "Admin" ? "admin" : "client";
  urlPre: any = localStorage.getItem("role") == "Admin" ? "admin" : "market";
  writeAccess: boolean =
    localStorage.getItem("acT") == "readandwrite" ||
    this.urlPrefix == "admin" ||
    localStorage.getItem("ut") == "admin";
  accessType: string = localStorage.getItem("acT");
  access: string = localStorage.getItem("accessType");
  customerType: string = localStorage.getItem("customerType");
  expiresIn: any = localStorage.getItem("expiresIn");
  totalPeriod: number = localStorage.getItem("totalPeriod")
    ? Number(localStorage.getItem("totalPeriod"))
    : 0;
  BOMAccess: boolean = this.urlPrefix === "admin";
  agl: any;
  eId: string;
  accId: string;

  // ── Access list ─────────────────────────────────────────────────────────────
  accessList: any = localStorage.getItem("menuList");

  // ── Dropdown state ──────────────────────────────────────────────────────────
  accountGroups: DropdownState<AccountGroup> = { list: [], selected: "" };
  clientNames: DropdownState<Client> = { list: [], selected: "" };
  accountIds: DropdownState<Account> = { list: [], selected: "" };
  tempAccountGroups: DropdownState<AccountGroup> = { list: [], selected: "" };
  tempClientNames: DropdownState<Client> = { list: [], selected: "" };
  tempAccountIds: DropdownState<Account> = { list: [], selected: "" };

  accountIdSearchTerm: any;
  clientNameSearchTerm: any;
  accountGroupSearchTerm: any;
  isdropdownop: boolean = false;
  previousClientName: string | null = null;

  // ── Cloud / region ──────────────────────────────────────────────────────────
  selectedCloudPartner: string = localStorage.getItem("cp-selected");
  selectedRegion = "Asia Pacific (Mumbai) ap-south-1";
  selectedRegionId = "ap-south-1";
  regions: any = { enabled: [], disabled: [] };
  continents: any = [];
  selectedResourceGroup: string;
  resourceGroups: any = [];

  // ── Loading ─────────────────────────────────────────────────────────────────
  loading: any = {
    // jobs: false, // disabled with eco cloud feature
    clientList: false,
    accountList: false,
  };

  // ── Greengame / jobs (disabled) ─────────────────────────────────────────────
  // jobs: any = [];
  // perPage: number = 10;
  // pages: any = [10, 50, 100, 200];
  // page: number = 1;
  // selectedJob: any;
  // selectedJobID: any;
  // monthYear: string = null;
  // totalDiscount: any;
  // discountPercentage: any;
  // checkCount = 0;
  // checkInterval = 10000;
  // stars: any = [1, 2, 3];
  // jobCurrentStatus = "";
  // filter: any = { checks: "ALL", findings: "ALL" };
  // checks: any = [];
  // checksAcc: any = [];
  dateRange: any = ""; // kept for ngOnInit initialization
  // progresspercentage: number;
  // acc_cftstatus: any;
  // levelsMap: { [key: string]: number } = { level1: 1, level2: 2, level3: 3 };

  // ── Misc ────────────────────────────────────────────────────────────────────
  currentPageLink: string;
  currentRoute: string = null;
  searchValue: string = "";
  recentSearchs: any = [];
  searchData: any = SearchData;
  searchResults: any;
  noticount: any = 0;
  notification: any[] = [];
  plans: any = {
    standard: "Standard",
    advanced: "Advanced",
    freetrial: "Free Trial",
  };
  expanded: any = {
    site24x7: false,
    infra: false,
    security: false,
    maintenance: false,
    expenditure: false,
    optimization: false,
  };
  whitelabelData: any = {
    pd: { appName: "", logoDark: "", logoLight: "" },
  };

  // ── Validation rules (unchanged) ────────────────────────────────────────────
  validations: ValidationRule[] = [
    {
      router: "/dash/accounts/aws",
      condition: () =>
        this.urlPrefix == "client" &&
        this.customerType == "mp" &&
        this.ut == "admin" &&
        !this.isUserAdmin,
      title: "AWS",
    },
    {
      router: "/dash/wafr",
      condition: () =>
        this.checkIfAvaForUser("Compliance") &&
        this.productType != "WAFR" &&
        this.selectedCloudPartner == "aws",
      title: "WAFR",
    },
    {
      router: "/dash/ticket/create",
      condition: () =>
        (this.checkIfAvaForUser("cloudSupport") ||
          this.checkIfAvaForUser("Support")) &&
        this.writeAccess,
      title: "Create Ticket",
    },
    {
      router: "/dash/ticket/list",
      condition: () =>
        this.checkIfAvaForUser("cloudSupport") ||
        this.checkIfAvaForUser("Support"),
      title: "View Tickets",
    },
    {
      router: "/dash/knowledgebase",
      condition: () =>
        (this.checkIfAvaForUser("cloudSupport") ||
          this.checkIfAvaForUser("Support")) &&
        this.urlPrefix == "admin",
      title: "Knowledge Base",
    },
    {
      router: "/dash/dashboard",
      condition: () =>
        (this.checkIfAvaForUser("cloudSupport") ||
          this.checkIfAvaForUser("Support")) &&
        this.canAccessSupportDashboard(),
      title: "Support Dashboard",
    },
    { router: "/dash/home", condition: "", title: "Global" },
    {
      router: "/dash/compliance/dash",
      condition: () =>
        this.checkIfAvaForUser("Governance") ||
        this.checkIfAvaForUser("Compliance"),
      title: "Governance",
    },
    {
      router: "/dash/operations/tags",
      condition: () => this.checkIfAvaForUser("Operations"),
      title: "EC2",
    },
    {
      router: "/dash/operations/rds",
      condition: () => this.checkIfAvaForUser("Operations"),
      title: "RDS",
    },
    {
      router: "/dash/operations/ebs",
      condition: () => this.checkIfAvaForUser("Operations"),
      title: "EBS",
    },
    {
      router: "/dash/operations/acm",
      condition: () => this.checkIfAvaForUser("Operations"),
      title: "ACM",
    },
    {
      router: "/dash/compliance/tags",
      condition: () => this.checkIfAvaForUser("Operations"),
      title: "Tags",
    },
    {
      router: "/dash/compliance/cloudtrail",
      condition: () => this.checkIfAvaForUser("Compliance"),
      title: "Cloud Trail",
    },
    {
      router: "/dash/s3/operations",
      condition: () => this.checkIfAvaForUser("Operations"),
      title: "S3",
    },
    { router: "/dash/compliance/dash", condition: "", title: "Dashboard" },
    {
      router: "/dash/compliance/findings?audit_type=ec2",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "EC2",
    },
    {
      router: "/dash/compliance/findings?audit_type=elb",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "ELB",
    },
    {
      router: "/dash/compliance/findings?audit_type=s3",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "S3",
    },
    {
      router: "/dash/compliance/s3/age_report",
      condition: () => this.checkIfAvaForUser("s3") && this.writeAccess,
      title: "S3 Age Report",
    },
    {
      router: "/dash/compliance/findings?audit_type=sg",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Security Groups",
    },
    {
      router: "/dash/compliance/findings?audit_type=apigateway",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "API Gateway",
    },
    {
      router: "/dash/compliance/findings?audit_type=lambda",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Lambda",
    },
    {
      router: "/dash/compliance/findings?audit_type=ses",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "SES",
    },
    {
      router: "/dash/compliance/findings?audit_type=sns",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "SNS",
    },
    {
      router: "/dash/compliance/findings?audit_type=kube",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "EKS",
    },
    {
      router: "/dash/compliance/findings?audit_type=dynamo",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "DynamoDB",
    },
    {
      router: "/dash/compliance/findings?audit_type=es",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Elastic Search",
    },
    {
      router: "/dash/compliance/findings?audit_type=rds",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "RDS",
    },
    {
      router: "/dash/compliance/findings?audit_type=cloudfront",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Cloudfront",
    },
    {
      router: "/dash/compliance/ebs",
      condition: () => this.checkIfAvaForUser("Compliance"),
      title: "EBS",
    },
    {
      router: "/dash/compliance/findings?audit_type=redshift",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Redshift",
    },
    {
      router: "/dash/compliance/findings?audit_type=cloudtrail",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Cloudtrail Compliance",
    },
    {
      router: "/dash/compliance/findings?audit_type=route53",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Route 53",
    },
    {
      router: "/dash/billing/billing-daily",
      condition: () =>
        this.checkIfAvaForUser("Cost Controls") ||
        this.checkIfAvaForUser("CostOptimization"),
      title: "Daily Variance Report",
    },
    {
      router: "/dash/billing/billing-anomaly",
      condition: () =>
        this.checkIfAvaForUser("Cost Controls") ||
        this.checkIfAvaForUser("CostOptimization"),
      title: "Cost Anomaly Report",
    },
    {
      router: "/dash/costopt/ec2",
      condition: () =>
        this.checkIfAvaForUser("CostOptimization") ||
        this.checkIfAvaForUser("Cost Controls"),
      title: "EC2",
    },
    {
      router: "/dash/costcontrols/ec2-ri",
      condition: () =>
        this.checkIfAvaForUser("CostOptimization") ||
        this.checkIfAvaForUser("Cost Controls"),
      title: "RI Recommendations",
    },
    {
      router: "/dash/cost-controls/reserved-instances",
      condition: () =>
        this.checkIfAvaForUser("CostOptimization") ||
        this.checkIfAvaForUser("Cost Controls"),
      title: "Reserved Instances",
    },
    {
      router: "/dash/costoptimization/ebs",
      condition: () =>
        this.checkIfAvaForUser("CostOptimization") ||
        this.checkIfAvaForUser("Cost Controls"),
      title: "EBS",
    },
    {
      router: "/dash/costopt/floating",
      condition: () =>
        this.checkIfAvaForUser("CostOptimization") ||
        this.checkIfAvaForUser("Cost Controls"),
      title: "AMIs and Snapshots",
    },
    {
      router: "/dash/s3/cost-controls",
      condition: () =>
        this.checkIfAvaForUser("CostOptimization") ||
        this.checkIfAvaForUser("Cost Controls"),
      title: "S3",
    },
    {
      router: "/dash/cost-controls/rds",
      condition: () =>
        this.checkIfAvaForUser("CostOptimization") ||
        this.checkIfAvaForUser("Cost Controls"),
      title: "RDS",
    },
    {
      router: "/dash/cost-controls/cloudwatch",
      condition: () =>
        this.checkIfAvaForUser("CostOptimization") ||
        this.checkIfAvaForUser("Cost Controls"),
      title: "Cloudwatch",
    },
    {
      router: "/dash/costopt/other",
      condition: () =>
        this.checkIfAvaForUser("CostOptimization") ||
        this.checkIfAvaForUser("Cost Controls"),
      title: "Other",
    },
    {
      router: "/dash/compliance/ssb",
      condition: () => this.checkIfAvaForUser("Security"),
      title: "Security Baseline",
    },
    {
      router: "/dash/security/ftr",
      condition: () => this.checkIfAvaForUser("Security"),
      title: "FTR",
    },
    {
      router: "/dash/wafr",
      condition: () => this.checkIfAvaForUser("Compliance"),
      title: "WAFR",
    },
    {
      router: "/dash/rbi-compliance",
      condition: () => this.checkIfAvaForUser("Compliance"),
      title: "RBI Compliance",
    },
    {
      router: "/dash/compliance/findings?audit_type=iam",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "IAM",
    },
    {
      router: "/dash/compliance/iam/users",
      condition: () => this.checkIfAvaForUser("Security") && this.writeAccess,
      title: "IAM Users",
    },
    {
      router: "/dash/compliance/iam/age_report",
      condition: () => this.checkIfAvaForUser("Security") && this.writeAccess,
      title: "IAM Access Key Age Report",
    },
    {
      router: "/dash/operations/sg",
      condition: () => this.checkIfAvaForUser("Security"),
      title: "Security Groups",
    },
    {
      router: "/dash/compliance/s3",
      condition: () => this.checkIfAvaForUser("Compliance"),
      title: "S3",
    },
    {
      router: "/dash/compliance/findings?audit_type=cft",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Cloud Formation",
    },
    {
      router: "/dash/compliance/findings?audit_type=kms",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "KMS",
    },
    {
      router: "/dash/compliance/patch",
      condition: () => this.checkIfAvaForUser("Compliance"),
      title: "Patch Report",
    },
    {
      router: "/dash/compliance/securityhub",
      condition: () => this.checkIfAvaForUser("Compliance"),
      title: "Security Hub",
    },
    {
      router: "/dash/compliance/advisor",
      condition: () => this.checkIfAvaForUser("Compliance"),
      title: "Trusted Advisor",
    },
    {
      router: "/dash/compliance/inspector",
      condition: () => this.checkIfAvaForUser("Security"),
      title: "Inspector",
    },
    {
      router: "/dash/compliance/config",
      condition: () => this.checkIfAvaForUser("Compliance"),
      title: "Config",
    },
    {
      router: "/dash/tell-me",
      condition: () => this.checkIfAvaForUser("Compliance"),
      title: "Tell Me",
    },
    {
      router: "/dash/compliance/findings?audit_type=cloudwatch",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Cloudwatch",
    },
    {
      router: "/dash/monitoring",
      condition: () =>
        this.checkIfAvaForUser("Monitoring") && this.customerType != "mp",
      title: "EMS Dashboard",
    },
    {
      router: "/dash/billing/dashboard",
      condition: () => this.checkIfAvaForUser("Billing"),
      title: "Dashboard",
    },
    {
      router: "/dash/billing",
      condition: () => this.checkIfAvaForUser("Billing"),
      title: "Monthly Bill",
    },
    {
      router: "/dash/billing/ri",
      condition: () =>
        this.checkIfAvaForUser("Billing") && this.urlPrefix == "admin",
      title: "RI Order Report",
    },
    {
      router: "/dash/billing/masterstatus",
      condition: () =>
        this.checkIfAvaForUser("Billing") && this.urlPrefix == "admin",
      title: "Master Status Overview",
    },
    {
      router: "/dash/sla/dashboard",
      condition: () => this.checkIfAvaForUser("SLAReport"),
      title: "SLA Dashboard",
    },
    {
      router: "/dash/sla/createdvsresolved",
      condition: () => this.checkIfAvaForUser("SLAReport"),
      title: "Created vs Resolved",
    },
    {
      router: "/dash/sla/firstresponsesla",
      condition: () => this.checkIfAvaForUser("SLAReport"),
      title: "First Response SLA",
    },
    {
      router: "/dash/sla/resolutionsla",
      condition: () => this.checkIfAvaForUser("SLAReport"),
      title: "Resolution SLA",
    },
    {
      router: "/dash/reports/view",
      condition: () => this.checkIfAvaForUser("Reports"),
      title: "View and Download Reports",
    },
    {
      router: "/dash/reports/enable",
      condition: () => this.checkIfAvaForUser("Reports") && this.writeAccess,
      title: "Automated Reports",
    },
    {
      router: "/dash/beta/automation/scheduler",
      condition: () => this.checkIfAvaForUser("Automation"),
      title: "Scheduler",
    },
    {
      router: "/dash/bom/upload",
      condition: () => this.checkIfAvaForUser("BOM") && this.writeAccess,
      title: "Upload BOM",
    },
    {
      router: "/dash/bom/view",
      condition: () => this.checkIfAvaForUser("BOM"),
      title: "View BOM Details",
    },
    {
      router: "/dash/bom/deltareport",
      condition: () => this.checkIfAvaForUser("BOM"),
      title: "Delta Report",
    },
    {
      router: "/dash/site24x7/monitors",
      condition: () => true,
      title: "Monitors",
    },
    {
      router: "/dash/beta/costoptimization/tags",
      condition: () => this.checkIfAvaForUser("Beta") && this.betaAccess,
      title: "Tags Cost Controls",
    },
    {
      router: "/dash/beta/ticket/create",
      condition: () =>
        this.checkIfAvaForUser("cloudSupport:ticket") && this.writeAccess,
      title: "Create Ticket",
    },
    {
      router: "/dash/beta/iam/groups",
      condition: () => this.checkIfAvaForUser("iam") && this.writeAccess,
      title: "IAM Groups",
    },
    {
      router: "/dash/azure/vms",
      condition: () => this.checkIfAvaForUser("Operations"),
      title: "VMs",
    },
    {
      router: "/dash/azure/disks",
      condition: () => this.checkIfAvaForUser("Operations"),
      title: "Disks",
    },
    {
      router: "/dash/azure/networks",
      condition: () => this.checkIfAvaForUser("Operations"),
      title: "Networks",
    },
    {
      router: "/dash/azure/databases",
      condition: () => this.checkIfAvaForUser("Operations"),
      title: "Databases",
    },
    {
      router: "/dash/azure/functions",
      condition: () => this.checkIfAvaForUser("Operations"),
      title: "Functions",
    },
    {
      router: "/dash/azure/tell-me",
      condition: () => this.checkIfAvaForUser("Monitoring"),
      title: "Tell Me",
    },
    {
      router: "/dash/azure/alerts",
      condition: () => this.checkIfAvaForUser("Alerts"),
      title: "Alerts",
    },
    {
      router: "/dash/compliance/findings?audit_type=sql_audit",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "SQL",
    },
    {
      router: "/dash/compliance/findings?audit_type=vm_audit",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "VM",
    },
    {
      router: "/dash/compliance/findings?audit_type=app_service_audit",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "App Service",
    },
    {
      router: "/dash/compliance/findings?audit_type=network_audit",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Network",
    },
    {
      router: "/dash/compliance/findings?audit_type=key_vault_audit",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Key Vault",
    },
    {
      router: "/dash/compliance/findings?audit_type=monitor_audit",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Monitor",
    },
    {
      router: "/dash/compliance/findings?audit_type=log_alert_audit",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Log Alert",
    },
    {
      router: "/dash/compliance/findings?audit_type=security_center_audit",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Security Center",
    },
    {
      router: "/dash/compliance/findings?audit_type=storage_audit",
      condition: () => this.checkIfAvaForUser("Governance"),
      title: "Storage",
    },
    {
      router: "/dash/settings/users/view",
      condition: () =>
        (this.checkIfAvaForUser("Settings") && this.ut == "admin") ||
        this.isUserAdmin,
      title: "Users",
    },
    {
      router: "/dash/settings/policies/view",
      condition: () =>
        this.checkIfAvaForUser("Settings") &&
        this.urlPrefix == "client" &&
        (this.ut == "admin" || this.isUserAdmin),
      title: "Policies",
    },
    {
      router: "/dash/settings/audittrail",
      condition: () => this.checkIfAvaForUser("Settings"),
      title: "Audit Trail",
    },
    {
      router: "/dash/settings/profile",
      condition: () => this.checkIfAvaForUser("Settings"),
      title: "User Management",
    },
    {
      router: "/dash/settings/approval-config",
      condition: () => this.checkIfAvaForUser("Settings"),
      title: "Approval Config",
    },
    // FeatureXpress (Feedback) menu disabled
    // {
    //   router: "/dash/feedback",
    //   condition: () => this.checkIfAvaForUser("Feedback"),
    //   title: "Feedback",
    // },
  ];

  whatsNew: any = [
    {
      name: "Tell Me",
      url: "/dash/tell-me",
      permission: () =>
        this.checkIfAvaForUser("Monitoring") &&
        moment().valueOf() <
          moment("22-06-2023", "DD-MM-YYYY").endOf("day").valueOf(),
      validTill: "22-06-2023",
      icon: "https://s3.ap-south-1.amazonaws.com/v3.assets.swayam.cloud/v3.icons/PNG/Blue/4x/Tell+Me+Feature%404x.png",
    },
    {
      name: "EC2 Cost Controls",
      url: "/dash/costopt/ec2",
      permission: () =>
        (this.checkIfAvaForUser("Cost Controls") ||
          this.checkIfAvaForUser("CostOptimization") ||
          this.checkIfAvaForUser("Cost Controls")) &&
        moment().valueOf() <
          moment("22-06-2023", "DD-MM-YYYY").endOf("day").valueOf(),
      validTill: "22-06-2023",
      icon: "https://s3.ap-south-1.amazonaws.com/v3.assets.swayam.cloud/v3.icons/PNG/Blue/4x/Optimization%404x.png",
    },
  ];

  // ── Subscriptions ────────────────────────────────────────────────────────────
  private subscriptions: Subscription = new Subscription();
  dashServiveMessage: any;

  // ─── Constructor ─────────────────────────────────────────────────────────────

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiServer: APIService,
    private notifier: NotifierService,
    private dashService: DashService
  ) {
    // Whitelabel initialisation
    this.whitelabelData = this.route.snapshot.data.data;
    if (this.whitelabelData["pd"]) {
      localStorage.setItem(
        "whitelabelData",
        JSON.stringify(this.whitelabelData)
      );
      this.whitelabelData = this.route.snapshot.data.data;
      if (this.whitelabelData["pd"]["logoLight"]) {
        this.changeFavicon(this.whitelabelData["pd"]["logoLight"]);
      }
    }

    // Parse access-list from localStorage
    if (this.accessList) {
      let temp: any = [];
      try {
        const accessList: any = JSON.parse(this.accessList);
        temp = [...Object.keys(accessList)];
        for (const key in accessList) {
          if (accessList.hasOwnProperty(key)) {
            const values = accessList[key].map(
              (value: any) => `${key.trim()}:${value.trim()}`
            );
            temp.push(...values);
          }
        }
        this.accessList = temp;
      } catch {
        this.accessList = [];
      }
    }

    // Track route changes — handle account-expired banner and mandatory CFT check
    const routerSub = this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.currentRoute = e.url;
        const currentUrl = e.urlAfterRedirects || e.url || "";
        if (
          this.isSupportDashboardRoute(currentUrl) &&
          !this.canAccessSupportDashboard()
        ) {
          this.router.navigate(["/dash/home"]);
          return;
        }
        if (localStorage.getItem("accountStatus") == "Inactive") {
          this.showExpired = e.url.indexOf("/dash/renewal") < 0;
          if (this.showExpired) {
            this.notifier.loading(false);
          }
        } else {
          this.showExpired = false;
        }
        this.currentPageLink = e.url;
        this.checkForMandatory();
      }
    });
    this.subscriptions.add(routerSub);
  }

  // ─── Lifecycle ────────────────────────────────────────────────────────────────

  async ngOnInit(): Promise<void> {
    this.notifier.loading(true);
    this.accId = localStorage.getItem("accountId");
    this.eId = localStorage.getItem("eId");
    this.dateRange = moment().startOf("month").format("MM-YYYY");
    $("#datetimepicker").val(moment().startOf("month").format("MM-YYYY"));

    this.dashServiveMessage = this.dashService.currentMessage.subscribe(
      (msg: any) => {
        if (!msg) return;
        const parsed = JSON.parse(msg);

        if (parsed["action"] == "refresh_accounts") {
          localStorage.removeItem("accountListNew");
          if (this.urlPrefix == "admin") {
            this.loadAccountList(localStorage.getItem("selectedClientList"));
          } else {
            this.loadAccounts();
          }
        } else if (parsed["action"] == "green_game") {
          // this.greengame(parsed["data"]["date"]); // disabled with eco cloud feature
        }
      }
    );

    this.regions = regions;

    if (localStorage.getItem("accountStatus") == "Inactive") {
      return;
    }

    if (this.urlPrefix == "admin") {
      this.checkForCBS();
    }

    if (this.customerType != "mp") {
      this.started = true;
    }

    this.checkForBetaAccess();
    await this.loadHeader();
    this.notifier.loading(false);
  }

  ngOnDestroy(): void {
    this.dashServiveMessage?.unsubscribe();
    this.subscriptions.unsubscribe();
  }

  // ─── Whitelabel ───────────────────────────────────────────────────────────────

  changeFavicon(newFaviconURL: any): void {
    const favicon: any = document.getElementById("favicon");
    if (favicon) {
      favicon.href = newFaviconURL;
    } else {
      const newFavicon = document.createElement("link");
      newFavicon.rel = "icon";
      newFavicon.type = "image/png";
      newFavicon.href = newFaviconURL;
      newFavicon.id = "favicon";
      document.head.appendChild(newFavicon);
    }
  }

  // ─── Mandatory CFT check ──────────────────────────────────────────────────────

  checkForMandatory(): void {
    const check: any = Object.keys(cftrequired).find((feature: string) =>
      window.location.pathname.indexOf(cftrequired[feature]["link"]) > -1
    );
    this.mandatory = !!check;
  }

  checkForEMS(): boolean {
    return (
      emsIntegration.includes(this.currentPageLink) &&
      !localStorage.getItem("emsConfig") &&
      !!this.getCurrentAccount() &&
      !this.getCurrentAccount()["site_247_project_id"]
    );
  }

  // ─── whatsNew ─────────────────────────────────────────────────────────────────

  totalWhatsNew(): any[] {
    return this.whatsNew.filter((item: any) => item["permission"]());
  }

  // ─── BU (Business Unit) creation ─────────────────────────────────────────────

  createBUCheck(event: any): void {
    if (event) {
      localStorage.removeItem("accountListNew");
      if (this.urlPrefix == "admin") {
        this.loadAccountList(localStorage.getItem("selectedClientList"));
      } else {
        this.loadAccounts();
      }
    }
    this.enableBU = false;
  }

  // ─── CFT link ────────────────────────────────────────────────────────────────

  async loadCFTLink(): Promise<void> {
    const apiURL = `https://prod.api.swayam.cloud/v3/cft`;
    const header = { Authorization: localStorage.getItem("t") };
    const result: any = await this.apiServer.postDataPromis(apiURL, {}, header);
    if (result.status == "1" || result.s == "1") {
      this.link = result["template_url"].replace(
        "RootAdminEmailIdValue",
        this.userId || localStorage.getItem("eId")
      );
    }
  }

  // ─── Beta / CBS access checks ─────────────────────────────────────────────────

  async checkForBetaAccess(): Promise<void> {
    const data = {
      action: "check_user",
      uid: localStorage.getItem("eId"),
    };
    const header = { Authorization: localStorage.getItem("t") };
    const apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/users/checkdevuser`;
    const result = await this.apiServer.postDataPromis(apiURL, data, header);
    if (result.s == "1" || result.status == "1") {
      this.betaAccess = result.msg == "Y";
    }
  }

  async checkForCBS(): Promise<void> {
    const data = { emailID: localStorage.getItem("eId") };
    const header = { Authorization: localStorage.getItem("t") };
    const apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/billing/fetchcbsuserstatus`;
    const result = await this.apiServer.postDataPromis(apiURL, data, header);
    if ((result.s == "1" || result.status == "1") && result.enableCBS) {
      this.cbsAccess = true;
    }
  }

  // ─── CFT validation ───────────────────────────────────────────────────────────

  /**
   * Validates CFT (CloudFormation Template) access for the given AWS account.
   * Azure accounts are never passed here — they get `cft_status = true` directly.
   */
  async checkForCFT(account: Account, select: boolean = true): Promise<any> {
    if (account["cft_status"] == undefined) {
      account["cft_status"] = "loading";
    }

    const data = {
      action: "validate_access",
      iam_role_arn: `arn:aws:iam::${account["accountId"]}:role/msopsstsrole`,
      session_name: "Swayam@AssumeRoleValidate",
    };
    const header = { Authorization: localStorage.getItem("t") };
    const apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/accounts/validate`;

    const result: any = await this.apiServer.postDataPromis(
      apiURL,
      data,
      header
    );

    if (result.status == "1" || result.s == "1") {
      account["cft_status"] = true;
      account["cft_latest_version"] = moment(
        result["LatestStackVersion"],
        "DD-MM-YYYY"
      ).valueOf();
      account["cft_latest_version_raw"] = result["LatestStackVersion"];
      try {
        if (moment(result["StackVersion"], "DD-MM-YYYY", true).isValid()) {
          account["cft_current_version"] = moment(
            result["StackVersion"],
            "DD-MM-YYYY"
          ).valueOf();
        } else {
          account["cft_current_version"] = moment(
            "01-01-2023",
            "DD-MM-YYYY"
          ).valueOf();
        }
      } catch {
        account["cft_current_version"] = moment(
          "01-01-2023",
          "DD-MM-YYYY"
        ).valueOf();
      }
      if (result["CloudShell"]) {
        result["CloudShell"]["Command"] = result["CloudShell"]["Command"].replace(
          "RootAdminEmailIdValue",
          this.userId
        );
      }
      account["cft_latest_url"] = result["CloudShell"];
      account["cft_deployed_region"] = result["StackRegion"];

      const currentAccount: any = this.getCurrentAccount();
      if (
        currentAccount &&
        currentAccount["accountId"] == account["accountId"]
      ) {
        this.started = true;
      }
    } else {
      account["cft_status"] = false;
      account["cft_latest_url"] = this.link;
      if (
        this.customerType == "mp" &&
        localStorage.getItem("accountId") == account["accountId"] &&
        this.selectedCloudPartner != "azure"
      ) {
        this.started = false;
      }
    }

    if (
      localStorage.getItem("accountId") == account["accountId"] &&
      localStorage.getItem("role") == "Client" &&
      select
    ) {
      this.setAccountList(account["accountId"]);
    }

    return result;
  }

  // ─── Header / boot sequence ───────────────────────────────────────────────────

  /**
   * Entry point for the boot sequence.
   * - Client role  → loadAccounts() (flat list, single level)
   * - Admin role   → loadAccountGroups() (3-level hierarchy)
   * Sets `isInitialLoad = false` after the admin hierarchy is resolved.
   */
  async loadHeader(): Promise<boolean> {
    this.loadNotificationCount();
    setInterval(() => this.loadNotificationCount(), 3_600_000);

    this.loadCFTLink();
    this.notifier.loading(true);

    if (localStorage.getItem("role") == "Client") {
      const max = -219.99078369140625;
      const percent = (this.expiresIn / 15) * 100;
      this.width = ((100 - percent) / 100) * max;
      this.accountIds.list = [];
      this.loadAccounts();
      return false;
    }

    await this.loadAccountGroups();
    this.isInitialLoad = false;
    return true;
  }

  // ─── Admin 3-level hierarchy ──────────────────────────────────────────────────

  async fetchAccountGroups(): Promise<void> {
    this.notifier.loading(true);
    const data = {
      action: "fetchAllAccountGroups2",
      clientId: localStorage.getItem("eId"),
      userId: localStorage.getItem("eId"),
      ut: localStorage.getItem("ut"),
    };
    const header = { Authorization: localStorage.getItem("t") };
    const apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/users/fetchaccountgroupsv2`;

    const result: any = await this.apiServer.postDataPromis(
      apiURL,
      data,
      header
    );

    if (result.s == "1" && result.agl) {
      result.agl.sort((a: any, b: any) =>
        a.groupName < b.groupName ? -1 : a.groupName > b.groupName ? 1 : 0
      );
      localStorage.setItem("accountGroups", JSON.stringify(result.agl));
      await this.loadAccountGroups();
    }
  }

  async loadAccountGroups(): Promise<void> {
    const raw = localStorage.getItem("accountGroups");
    try {
      const data: AccountGroup[] = JSON.parse(raw);
      if (data && data.length > 0) {
        this.accountGroups.list = data.sort((a, b) =>
          a.groupName < b.groupName ? -1 : a.groupName > b.groupName ? 1 : 0
        );
        this.tempAccountGroups.list = JSON.parse(
          JSON.stringify(this.accountGroups.list)
        );

        const prev = localStorage.getItem("selectedAccountGroup");
        if (prev) {
          await this.setAccountGroup(prev, false);
        } else {
          this.accountGroups.selected = data[0].groupName;
          this.tempAccountGroups.selected = data[0].groupName;
          localStorage.setItem("selectedAccountGroup", data[0].groupName);
          localStorage.setItem("accountGroups", JSON.stringify(data));
          await this.fetchClientList(data[0].groupName, false, true);
        }
      } else {
        await this.fetchAccountGroups();
      }
    } catch {
      await this.fetchAccountGroups();
    }
  }

  /**
   * Sets the active account group and triggers a client-list load.
   * `isInitialLoad` controls whether the selection is persisted to localStorage.
   */
  async setAccountGroup(
    groupName: any,
    isInitialLoad: boolean = true
  ): Promise<void> {
    this.accountIdSearchTerm = null;
    this.clientNameSearchTerm = null;
    this.accountGroupSearchTerm = null;
    this.accountGroups.selected = groupName;

    await this.fetchClientList(groupName);

    if (isInitialLoad) {
      localStorage.setItem("selectedAccountGroup", groupName);
    }
  }

  async fetchClientList(
    groupName: any,
    isTemp: boolean = false,
    isInitialLoad: boolean = false
  ): Promise<void> {
    if (!isTemp) this.notifier.loading(true);

    const data = {
      action: "fetchSwayamClientList",
      clientId: localStorage.getItem("eId"),
      userId: localStorage.getItem("eId"),
      groupName,
      ut: "admin",
    };
    const header = { Authorization: localStorage.getItem("t") };
    const apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/users/fetchaccountgroupsv2`;

    const result: any = await this.apiServer.postDataPromis(
      apiURL,
      data,
      header
    );

    if (result.s == "1" && result.agl) {
      const clientListData = result.agl[0]["accountGroup"]["accountGroupList"][
        "accountGroupDetails"
      ].sort((a: any, b: any) =>
        a.cmpName < b.cmpName ? -1 : a.cmpName > b.cmpName ? 1 : 0
      );

      if (isTemp) {
        await this.loadTempClientList(groupName, clientListData);
      } else {
        await this.loadClientList(groupName, clientListData, isInitialLoad);
      }
    }
  }

  async loadClientList(
    groupName: any,
    clientListData?: Client[],
    isInitialLoad: boolean = false
  ): Promise<void> {
    let data: Client[] = clientListData ?? null;
    if (!data) {
      const raw = localStorage.getItem("clientList");
      if (raw) data = JSON.parse(raw);
    }

    if (!data || data.length === 0) {
      await this.fetchClientList(groupName, false, isInitialLoad);
      return;
    }

    this.clientNames.list = data
      .map((client: any) => {
        client["cmpName"] = client["cmpName"].trim();
        return client;
      })
      .sort((a: any, b: any) =>
        a.cmpName < b.cmpName ? -1 : a.cmpName > b.cmpName ? 1 : 0
      );

    if (isInitialLoad) {
      this.tempClientNames.list = JSON.parse(
        JSON.stringify(this.clientNames.list)
      );
    }

    const prev = localStorage.getItem("selectedClientList");

    if (isInitialLoad) {
      this.clientNames.selected = data[0]["cmpName"];
      this.tempClientNames.selected = data[0]["cmpName"];
      localStorage.setItem("selectedClientName", this.clientNames.selected || "");
      localStorage.setItem(
        "selectedClientNameData",
        JSON.stringify(this.clientNames)
      );
      localStorage.setItem("selectedClientList", data[0]["emailId"]);
      localStorage.setItem("clientList", JSON.stringify(data));
      this.enforceSupportDashboardAccess();
      await this.fetchAccountList(data[0]["emailId"], false, true);
    } else if (
      prev &&
      localStorage.getItem("selectedAccountGroup") == groupName
    ) {
      await this.setClientList(prev);
    } else {
      await this.setClientList(data[0]["emailId"]);
    }
  }

  async loadTempClientList(
    groupName: any,
    clientListData?: Client[]
  ): Promise<void> {
    let data: Client[] = clientListData ?? null;
    if (!data) {
      const raw = localStorage.getItem("clientList");
      if (raw) data = JSON.parse(raw);
    }

    if (!data || data.length === 0) {
      await this.fetchClientList(groupName, true);
      return;
    }

    this.tempClientNames.list = data
      .map((client: any) => {
        client["cmpName"] = client["cmpName"].trim();
        return client;
      })
      .sort((a: any, b: any) => a.cmpName.localeCompare(b.cmpName));

    const prev = localStorage.getItem("selectedClientList");
    if (prev && localStorage.getItem("selectedAccountGroup") === groupName) {
      const client = this.tempClientNames.list.find(
        (c: any) => c.emailId === prev
      );
      this.tempClientNames.selected = client
        ? client.cmpName
        : this.tempClientNames.list[0].cmpName;
    } else {
      this.tempClientNames.selected = this.tempClientNames.list[0].cmpName;
    }
  }

  async setClientList(clientName: any): Promise<boolean> {
    $("#wait").show();
    this.accountIdSearchTerm = null;
    this.clientNameSearchTerm = null;
    this.accountGroupSearchTerm = null;

    this.clientNames.selected =
      this.clientNames?.list?.find(
        (client: any) => client.emailId?.trim() == clientName?.trim()
      )?.cmpName || "";

    // Keep selected client persisted for route/menu guards (for example Support Dashboard access).
    localStorage.setItem("selectedClientName", this.clientNames.selected || "");
    localStorage.setItem(
      "selectedClientNameData",
      JSON.stringify(this.clientNames)
    );
    this.enforceSupportDashboardAccess();

    const prev = localStorage.getItem("selectedClientList");
    
    if (!this.isInitialLoad) {
      localStorage.setItem("selectedClientList", clientName);
    }

    if (prev && prev != clientName) {
      await this.fetchAccountList(clientName);
    } else if (prev) {
      await this.loadAccountList(clientName);
    } else {
      await this.fetchAccountList(clientName);
    }

    this.loadMonitorGroups();
    return true;
  }

  async fetchAccountList(
    clientName: any,
    isTemp: boolean = false,
    isInitialLoad: boolean = false
  ): Promise<void> {
    if (!isTemp) {
      this.notifier.loading(true);
      this.loading.accountList = true;
      this.accountIds.list = [];
    }

    const data = { a: "fetchAccounts", eId: clientName };
    const header = { Authorization: localStorage.getItem("t") };
    const awsApiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/users/awsaccounts`;
    const azureApiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/users/azureaccounts`;

    try {
      const [awsResult, azureResult] = await Promise.all([
        this.apiServer.postDataPromis(awsApiURL, data, header),
        this.apiServer
          .postDataPromis(azureApiURL, data, header)
          .catch(() => ({ s: "0", accounts: [] as any[] })),
      ]);

      if (awsResult?.config) {
        if (!isTemp) {
          localStorage.setItem("emsConfig", JSON.stringify(awsResult.config));
        }
        this.loadMonitorGroups();
      } else if (localStorage.getItem("emsConfig")) {
        localStorage.removeItem("emsConfig");
      }

      const awsAccounts = this.normalizeAwsAccounts(awsResult?.accounts || []);
      const azureAccounts = this.normalizeAzureAccounts(
        azureResult?.accounts || []
      );
      const mergedAccounts = this.mergeAndSortAccounts(
        awsAccounts,
        azureAccounts
      );

      if (mergedAccounts.length > 0) {
        if (!isTemp) {
          this.accountIds.list = [...mergedAccounts];
          await this.loadAccountList(clientName, mergedAccounts, isInitialLoad);
        } else {
          this.tempAccountIds.list = [...mergedAccounts];
        }

        if (this.accountIds.list.length == 0) {
          this.loadRegions();
        }
      }
    } finally {
      if (!isTemp) {
        this.loading.accountList = false;
      }
    }
  }

  async loadAccountList(
    clientList: any,
    accountListData?: Account[],
    isInitialLoad: boolean = false
  ): Promise<void> {
    let data: Account[] = accountListData ?? null;
    if (!data) {
      const raw = localStorage.getItem("accountListNew");
      if (raw) data = JSON.parse(raw);
    }

    if (!data) {
      this.fetchAccountList(clientList);
      return;
    }

    if (data.length === 0) {
      await this.fetchClientList(this.accountGroups.selected);
      return;
    }

    this.accountIds.list = data.sort((a: any, b: any) =>
      a.accountName < b.accountName
        ? -1
        : a.accountName > b.accountName
        ? 1
        : 0
    );
    localStorage.setItem("accountListNew", JSON.stringify(data));
    localStorage.setItem("accountIdData", JSON.stringify(this.accountIds));

    if (isInitialLoad) {
      this.tempAccountIds.list = JSON.parse(
        JSON.stringify(this.accountIds.list)
      );
    }

    const prev = localStorage.getItem("accountId");

    if (isInitialLoad) {
      this.accountIds.selected =
        data[0].accountName + `(${data[0].accountId})`;
      this.tempAccountIds.selected =
        data[0].accountName + `(${data[0].accountId})`;
      localStorage.setItem("accountId", data[0].accountId);
      localStorage.setItem("accountListNew", JSON.stringify(data));
      localStorage.setItem("accountIdData", JSON.stringify(this.accountIds));

      if (data[0]) {
        localStorage.setItem("swayam_jira_org_id", data[0].jira_org_id);
        localStorage.setItem("swayam_jira_org_name", data[0].jira_org_name);
        localStorage.setItem(
          "swayam_jira_project_id",
          data[0].jira_project_id
        );
        localStorage.setItem(
          "swayam_jira_project_key",
          data[0].jira_project_key
        );
        localStorage.setItem(
          "swayam_jira_project_name",
          data[0].jira_project_name
        );
        localStorage.setItem(
          "swayam_site_247_project_id",
          data[0].site_247_project_id
        );
        localStorage.setItem(
          "site_247_project_name",
          data[0].site_247_project_name
        );
        localStorage.setItem("monitoringUrl", data[0].monitoringUrl);
      }
      this.notifier.loading(false);
    }

    // Check CFT for all AWS accounts; mark Azure accounts as always valid
    const cftPromises: Promise<any>[] = [];
    this.accountIds.list.forEach((account: any) => {
      if (account["cp"] != "azure") {
        cftPromises.push(this.checkForCFT(account));
      } else {
        account["cft_status"] = true;
      }
    });

    await Promise.all(cftPromises);

    if (isInitialLoad) {
      await this.selectAccountId(data[0]);
    } else if (
      prev &&
      localStorage.getItem("selectedClientList") == clientList &&
      this.accountIds.list.some((a: any) => a.accountId == prev)
    ) {
      await this.setAccountList(prev);
    } else {
      await this.setAccountList(data[0]["accountId"]);
    }
  }

  async setAccountList(accountId: any): Promise<boolean> {
    this.accountIdSearchTerm = null;
    this.clientNameSearchTerm = null;
    this.accountGroupSearchTerm = null;

    // Try to find account in persisted list first, then in memory list
    let account: Account = null;
    const rawList = localStorage.getItem("accountListNew");
    if (rawList) {
      const parsed: Account[] = JSON.parse(rawList);
      account = parsed.find((a) => a.accountId == accountId) ?? null;
    }
    if (!account) {
      account = this.accountIds.list.find((a: any) => a.accountId == accountId) ?? null;
    }

    if (!account) {
      this.notifier.loading(false);
      return false;
    }

    this.accountIds.selected =
      account.accountName + `(${account.accountId})`;

    if (
      !account["cft_status"] &&
      this.customerType == "mp" &&
      this.selectedCloudPartner != "azure"
    ) {
      this.started = false;
      this.router.navigate(["/dash/accounts/aws"]);
    } else {
      this.started = true;
    }

    if (!this.isInitialLoad) {
      localStorage.setItem("accountId", account.accountId);
      localStorage.setItem("swayam_jira_org_id", account.jira_org_id);
      localStorage.setItem("swayam_jira_org_name", account.jira_org_name);
      localStorage.setItem("swayam_jira_project_id", account.jira_project_id);
      localStorage.setItem(
        "swayam_jira_project_key",
        account.jira_project_key
      );
      localStorage.setItem(
        "swayam_jira_project_name",
        account.jira_project_name
      );
      localStorage.setItem(
        "swayam_site_247_project_id",
        account.site_247_project_id
      );
      localStorage.setItem(
        "site_247_project_name",
        account.site_247_project_name
      );
      localStorage.setItem("monitoringUrl", account.monitoringUrl);
    }

    await this.selectAccountId(account);

    if (this.urlPrefix == "client") {
      this.loadMonitorGroups();
    }
    if (this.selectedCloudPartner != "azure") {
      this.notifier.loading(false);
    }
    return true;
  }

  // ─── Temp account list (used by dropdown preview) ─────────────────────────────

  async loadTempAccountList(
    clientName: any,
    accountListData?: Account[]
  ): Promise<void> {
    let data: Account[] = accountListData ?? null;
    if (!data) {
      const raw = localStorage.getItem("accountListNew");
      if (raw) data = JSON.parse(raw);
    }

    if (!data || data.length === 0) {
      await this.fetchAccountList(clientName, true);
      return;
    }

    this.tempAccountIds.list = data.sort((a: any, b: any) =>
      a.accountName.localeCompare(b.accountName)
    );
    const prev = localStorage.getItem("accountId");
    if (prev && localStorage.getItem("selectedClientList") === clientName) {
      const found = this.tempAccountIds.list.find(
        (a: any) => a.accountId === prev
      );
      this.tempAccountIds.selected = found
        ? found.accountName + `(${found.accountId})`
        : this.tempAccountIds.list[0].accountName +
          `(${this.tempAccountIds.list[0].accountId})`;
    } else {
      this.tempAccountIds.selected =
        this.tempAccountIds.list[0].accountName +
        `(${this.tempAccountIds.list[0].accountId})`;
    }
  }

  // ─── Client/market account loading (non-admin) ────────────────────────────────

  async loadAccounts(): Promise<void> {
    this.notifier.loading(true);
    this.accountIds.list = [];

    const data: any = {
      a: "fetchAccounts",
      eId:
        localStorage.getItem("masterId") &&
        localStorage.getItem("masterId") != "undefined" &&
        this.isUserAdmin
          ? localStorage.getItem("masterId")
          : localStorage.getItem("eId"),
    };
    const header = { Authorization: localStorage.getItem("t") };
    const apiURL = `${APIService.API_ENDPOINTV3}/market/awsaccounts`;

    const result: any = await this.apiServer.postDataPromis(
      apiURL,
      data,
      header
    );

    if (result.s == "1" && result.accounts) {
      if (result.config) {
        this.loadMonitorGroups();
        localStorage.setItem("emsConfig", JSON.stringify(result.config));
      } else if (localStorage.getItem("emsConfig")) {
        localStorage.removeItem("emsConfig");
      }

      if (
        localStorage.getItem("productType") == "WAFR" &&
        (!result.accounts || result.accounts.length == 0)
      ) {
        this.router.navigate(["/dash/accounts/aws"]);
        this.started = false;
        this.notifier.loading(false);
      }

      result.accounts = result.accounts.map((account: any) => {
        account["cp"] = "aws";
        if (account["regions"] == undefined) account["regions"] = [];
        if (account["customeRegions"] != undefined)
          account["customRegions"] = account["customeRegions"];
        if (account["customRegions"] == undefined)
          account["customRegions"] = true;
        if (account["importType"] == undefined)
          account["importType"] = "automatic";
        if (result.config) {
          account["site_247_project_id"] = result["config"]["emsUid"];
          account["site_247_project_name"] = result["config"]["emsName"];
        }
        return account;
      });

      this.accountIds.list = [...this.accountIds.list, ...result.accounts];

      const selectedAccount = localStorage.getItem("accountId");
      if (!selectedAccount) {
        localStorage.setItem("accountId", this.accountIds.list[0].accountId);
      }
      const found = this.accountIds.list.find(
        (a: any) => a["accountId"] == selectedAccount
      );
      if (!found) {
        localStorage.setItem(
          "accountId",
          this.accountIds.list[0]["accountId"]
        );
      }
      localStorage.setItem("accountIdData", JSON.stringify(this.accountIds));

      const cftPromises: Promise<any>[] = [];
      this.accountIds.list.forEach((account: any) => {
        if (account["cp"] != "azure") {
          cftPromises.push(this.checkForCFT(account));
        } else {
          account["cft_status"] = true;
        }
      });
      Promise.all(cftPromises).then(() => {
        localStorage.setItem("accountIdData", JSON.stringify(this.accountIds));
      });
    } else {
      this.accountIds.list = [];
      if (this.customerType == "mp" && this.ut == "admin" && !this.isUserAdmin) {
        this.router.navigate(["/dash/accounts/aws"]);
        this.started = false;
      } else {
        localStorage.clear();
        this.notifier.alert(
          "Info",
          "",
          "Accounts not found. Please contact admin",
          "info",
          -1
        );
        this.router.navigate(["/login"]);
        this.notifier.loading(false);
        localStorage.clear();
        return;
      }
    }

    await this.fetchAzureSubscriptions(null);

    if (this.accountIds.list.length == 0) {
      await this.loadRegions();
    }
  }

  // ─── Azure subscriptions ──────────────────────────────────────────────────────

  async fetchAzureSubscriptions(
    clientName: string,
    isTemp: boolean = false
  ): Promise<void> {
    const data: any = {
      action: "list_subscriptions",
      user_id: localStorage.getItem("selectedClientList"),
    };
    const header = { Authorization: localStorage.getItem("t") };
    const apiUrl = `${environment.apiURL}/${this.urlPrefix}/azure/central`;

    const result: any = await this.apiServer.postDataPromis(
      apiUrl,
      data,
      header
    );

    if (result.status == "1" || result.s == "1") {
      const subs = result.subscriptions.map((s: any) => ({
        accountId: s["subscription_id"],
        accountName: s["subscription_name"],
        cp: "azure",
      }));
      if (isTemp) {
        this.tempAccountIds.list = [...this.tempAccountIds.list, ...subs];
      } else {
        this.accountIds.list = [...this.accountIds.list, ...subs];
      }
    } else {
      localStorage.removeItem("azureSubscriptions");
    }
  }

  // ─── Account normalisation helpers ────────────────────────────────────────────

  private normalizeAwsAccounts(accounts: any[]): Account[] {
    if (!Array.isArray(accounts)) return [];
    return accounts
      .map((a: any) => ({
        ...a,
        accountId: a.accountId || a.accountid,
        accountName: a.accountName || a.accountname,
        cp: "aws",
      }))
      .filter((a: any) => a.accountId && a.accountName);
  }

  private normalizeAzureAccounts(accounts: any[]): Account[] {
    if (!Array.isArray(accounts)) return [];
    return accounts
      .map((a: any) => ({
        ...a,
        accountId:
          a.accountId || a.accountid || a.subscriptionid || a.subscription_id,
        accountName:
          a.accountName ||
          a.accountname ||
          a.subscriptionname ||
          a.subscription_name,
        cp: "azure",
      }))
      .filter((a: any) => a.accountId && a.accountName);
  }

  private mergeAndSortAccounts(
    awsAccounts: Account[],
    azureAccounts: Account[]
  ): Account[] {
    const sortByName = (list: Account[]): Account[] =>
      [...(list || [])].sort((a, b) => {
        const an = (a.accountName || "").toLowerCase();
        const bn = (b.accountName || "").toLowerCase();
        return an < bn ? -1 : an > bn ? 1 : 0;
      });

    const dedupe = (list: Account[]): Account[] => {
      const seen: Record<string, boolean> = {};
      return (list || []).filter((a) => {
        const key = `${a.cp || ""}::${a.accountId || ""}`;
        if (seen[key]) return false;
        seen[key] = true;
        return true;
      });
    };

    return [
      ...sortByName(dedupe(awsAccounts)),
      ...sortByName(dedupe(azureAccounts)),
    ];
  }

  // ─── selectAccountId — core notification dispatch ─────────────────────────────

  /**
   * Called once the active account has been resolved (CFT checked, localStorage
   * written). This method:
   *   1. Updates selectedCloudPartner.
   *   2. Fetches Azure resource groups (skip-notification mode).
   *   3. Loads regions.
   *   4. Checks if a redirect is required (partner change, incompatible route,
   *      or missing CFT for mp customer).
   *   5. If redirect → navigate, no notifications (target page inits fresh).
   *   6. If no redirect → fire changeAccountIdNotification + region/resource-group
   *      notifications inside a 100 ms setTimeout.
   */
  async selectAccountId(accountId: Account): Promise<boolean> {
    if (accountId["accountId"] == "") return false;

    const prev = this.selectedCloudPartner;
    this.selectedCloudPartner = accountId["cp"].trim();
    localStorage.setItem("cp-selected", this.selectedCloudPartner);

    if (!this.isInitialLoad) {
      this.notifier.loading(false);
    }

    if (
      this.currentRoute &&
      this.currentRoute.indexOf("/billing") < 0 &&
      accountId["cp"] != "azure"
    ) {
      this.checkingCFT = true;
      const result: any = await this.checkForCFT(accountId, false);
      accountId["cft_status"] = result.status == "1" || result.s == "1";
      this.checkingCFT = false;
    }

    this.notifier.loading(true);

    if (accountId["cp"] == "azure") {
      await this.fetchResourceGroups(accountId, true);
    } else {
      localStorage.removeItem("resourceGroupsAccountId");
    }

    if (!this.isInitialLoad) {
      localStorage.setItem("selectedaccountIds", this.accountIds.selected);
      localStorage.setItem("accountId", accountId.accountId);
      localStorage.setItem("accountIdData", JSON.stringify(this.accountIds));
    }

    this.accountIds.selected =
      accountId.accountName + ` (${this.getSelectedAccountId()})`;

    if (
      !accountId["cft_status"] &&
      accountId["cft_status"] != undefined &&
      this.currentRoute &&
      this.currentRoute.indexOf("/billing") < 0 &&
      this.selectedCloudPartner != "azure"
    ) {
      this.currentAccountCFTStatus = true;
    }

    if (this.customerType == "mp") {
      if (accountId["cft_status"]) {
        this.started = true;
      } else {
        if (window.location.href.indexOf("accounts/aws") < 0) {
          this.router.navigate(["/dash/accounts/aws"]);
        }
        this.started = false;
      }
    }

    await this.loadRegions();

    // Resolve region (without notification — notification fires later)
    if (
      !localStorage.getItem("regionId") ||
      localStorage.getItem("regionId") == "null"
    ) {
      const accountData = this.accountIds["list"].find(
        (a: any) => a["accountId"] == localStorage.getItem("accountId")
      );
      if (accountData?.regions?.length > 0) {
        const region = this.regions["enabled"].find(
          (r: any) => r.id == accountData.regions[0]
        );
        await this.setRegion(region ?? this.regions["enabled"][0], false);
      } else if (this.regions["enabled"].length > 0) {
        await this.setRegion(this.regions["enabled"][0], false);
      }
    } else {
      const region = this.regions["enabled"].find(
        (r: any) => r.id == localStorage.getItem("regionId")
      );
      if (region) this.setRegion(region, false);
    }

    if (accountId["cp"] != "azure") {
      this.notifier.loading(false);
    }

    if (
      !localStorage.getItem("regionId") ||
      localStorage.getItem("regionId") == "null"
    ) {
      // Trigger Findings refresh before region is available.
      const activeUrl = this.router.url || "";
      if (activeUrl.startsWith("/dash/compliance/findings")) {
        this.notifier.changeAccountIdNotification(accountId.accountId);
      }
      this.isInitialLoad = false;
      return false;
    }

    this.checkForMandatory();

    // Keep governance pages in-place on cloud switch; components refresh via notifier events.
    // For non-governance pages, continue enforcing route cloud compatibility.
    {
      const newCp = this.selectedCloudPartner.toUpperCase();
      const activeUrl = this.router.url || "";
      const isGovernanceRoute = activeUrl.startsWith("/dash/compliance");
      // Walk the router snapshot tree to find the deepest activated route with permission data
      let snapshot = this.router.routerState.snapshot.root;
      while (snapshot.firstChild) {
        snapshot = snapshot.firstChild;
      }
      const routeAllowed: string[] | undefined =
        snapshot.data?.["permission"]?.["allowed_cloud_partners"];
      if (
        !isGovernanceRoute &&
        routeAllowed &&
        routeAllowed.length > 0 &&
        !routeAllowed.includes(newCp)
      ) {
        this.router.navigate(["/dash/home"]);
      }
    }

    // All localStorage values set — dispatch notifications
    this.isInitialLoad = false;
    if (this.selectedCloudPartner == "aws") {
      setTimeout(() => {
        this.notifier.changeRegionNotification(localStorage.getItem("regionId") || "");
        this.notifier.changeAccountIdNotification(accountId.accountId);
        // this.greengame(); // disabled with eco cloud feature
      }, 100);
    } else {
      setTimeout(() => {
        this.notifier.changeResourceGroup(localStorage.getItem("selectedResourceGroup") || "");
        this.notifier.changeRegionNotification(localStorage.getItem("regionId") || "");
        this.notifier.changeAccountIdNotification(accountId.accountId);
      }, 300);
    }

    return true;
  }

  // ─── Region management ────────────────────────────────────────────────────────

  async loadRegions(): Promise<boolean> {
    this.continents = [];
    const data: any = {
      a: "regions",
      accountId: localStorage.getItem("accountId") || null,
    };
    const header = { Authorization: localStorage.getItem("t") };
    const apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/globals`;

    const result: any = await this.apiServer.postDataPromis(
      apiURL,
      data,
      header
    );

    if (result.s == "1" || result.status == "1") {
      this.regions["enabled"] = result.data.filter((region: any) => {
        if (this.continents.indexOf(region["id"].split("-")[0]) < 0) {
          this.continents.push(region["id"].split("-")[0]);
        }
        return region["status"] == "enabled";
      });
      this.regions["disabled"] = result.data.filter(
        (r: any) => r["status"] != "enabled"
      );

      const accountData = this.accountIds["list"].find(
        (a: any) => a["accountId"] == localStorage.getItem("accountId")
      );

      if (accountData?.regions?.length > 0) {
        const region = this.regions["enabled"].find(
          (r: any) => r.id == accountData.regions[0]
        );
        await this.setRegion(region ?? this.regions["enabled"][0], false);
      } else {
        if (!localStorage.getItem("regionId")) {
          if (this.regions["enabled"].length > 0) {
            await this.setRegion(this.regions["enabled"][0], false);
          }
          return true;
        }
        const existing = this.regions["enabled"].find(
          (r: any) => r.id == localStorage.getItem("regionId")
        );
        if (existing) {
          await this.setRegion(existing, false);
        } else if (this.regions["enabled"].length > 0) {
          await this.setRegion(this.regions["enabled"][0], false);
        } else {
          return false;
        }
      }
      return true;
    } else {
      this.notifier.alert(
        "Info",
        "",
        result.message || result.error || result.error_message,
        "info",
        5000
      );
    }

    if (this.accountIds.list.length == 0) {
      this.notifier.loading(false);
    }
    return false;
  }

  async setRegion(region: Region, validate: boolean = true): Promise<void> {
    this.selectedRegion = region.name;
    localStorage.setItem("selectedRegion", region.name);
    localStorage.setItem("selectedRegionId", region.id);
    localStorage.setItem("regionId", region.id);
    if (validate) {
      this.notifier.changeRegionNotification(region.id);
    }
  }

  getRegions(continent: string, enabled: boolean = true): Region[] {
    return this.regions["enabled"].filter((region: any) => {
      return (
        this.getCurrentAccount() &&
        region.id.startsWith(continent) &&
        (!this.getCurrentAccount()["customeRegions"] ||
          (enabled ? this.checkRegion(this.getCurrentAccount(), region.id) : true))
      );
    });
  }

  getDisabledRegions(enabled: boolean = true): Region[] {
    return this.regions["disabled"].filter((region: any) => {
      return (
        this.getCurrentAccount() &&
        (!this.getCurrentAccount()["customeRegions"] ||
          (enabled ? this.checkRegion(this.getCurrentAccount(), region.id) : true))
      );
    });
  }

  checkRegion(account: any, region_id: any): boolean {
    return account.regions.indexOf(region_id) > -1;
  }

  // ─── Azure resource groups ────────────────────────────────────────────────────

  async fetchResourceGroups(
    account: Account,
    skipNotification: boolean = false
  ): Promise<void> {
    this.resourceGroups = [];
    const accountId = account["accountId"];
    const savedStateAccountId = localStorage.getItem("resourceGroupsAccountId");
    const isSameAccountState = savedStateAccountId == accountId;
    if (!isSameAccountState) {
      this.selectedResourceGroup = "";
      localStorage.setItem("selectedResourceGroup", "");
      localStorage.setItem("resourceGroups", "[]");
    }
    const storedResourceGroup = localStorage.getItem("selectedResourceGroup");
    let storedResourceGroups: any[] = [];
    if (isSameAccountState) {
      const storedResourceGroupsRaw = localStorage.getItem("resourceGroups");
      if (storedResourceGroupsRaw) {
        try {
          storedResourceGroups = JSON.parse(storedResourceGroupsRaw) || [];
        } catch {
          storedResourceGroups = [];
        }
      }
    }
    const data: any = {
      action: "list_resource_groups",
      user_id: localStorage.getItem("selectedClientList"),
      subscription_id: account["accountId"],
    };
    const header = { Authorization: localStorage.getItem("t") };
    const apiUrl = `${environment.apiURL}/${this.urlPrefix}/azure/central`;

    const result: any = await this.apiServer.postDataPromis(
      apiUrl,
      data,
      header
    );

    if (result.status == "1" || result.s == "1") {
      this.resourceGroups = result["resource_groups"] || [];
      if (this.resourceGroups.length > 0) {
        if (isSameAccountState && storedResourceGroups.length > 0) {
          this.resourceGroups.forEach((rg: any) => {
            const saved = storedResourceGroups.find(
              (savedRg: any) => savedRg.name == rg.name
            );
            rg["selected"] = !!(saved && saved["selected"]);
          });

          if (!this.resourceGroups.some((rg: any) => rg.selected)) {
            this.resourceGroups.forEach((rg: any, index: number) => {
              rg["selected"] = index < 5;
            });
          }

          const matchedResourceGroup = this.resourceGroups.find(
            (rg: any) => storedResourceGroup && storedResourceGroup == rg.name
          );
          if (matchedResourceGroup) {
            this.changeResourceGroup(matchedResourceGroup, !skipNotification);
          } else {
            this.changeResourceGroup(this.resourceGroups[0], !skipNotification);
          }
        } else {
          this.resourceGroups.forEach((rg: any, index: number) => {
            rg["selected"] = index < 5;
          });
          this.changeResourceGroup(this.resourceGroups[0], !skipNotification);
        }
      } else {
        this.selectedResourceGroup = "";
        localStorage.setItem("selectedResourceGroup", "");
        if (!skipNotification) {
          this.notifier.changeResourceGroup("");
        }
      }
      localStorage.setItem("resourceGroupsAccountId", accountId);
      localStorage.setItem(
        "resourceGroups",
        JSON.stringify(this.resourceGroups)
      );
    }
  }

  changeResourceGroup(resource: any, notify: boolean = true): void {
    localStorage.setItem("selectedResourceGroup", resource["name"]);
    localStorage.setItem("resourceGroupsAccountId", localStorage.getItem("accountId") || "");
    this.selectedResourceGroup = resource.name;
    if (notify) {
      this.notifier.changeResourceGroup(resource.name);
    }
  }

  filteredResourceGroups(): any[] {
    return this.resourceGroups.filter((rg: any) =>
      rg.name.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
    );
  }

  // Support Dashboard is intentionally restricted to NHA company only.
  isNhaCompany(): boolean {
    return isNhaCompany(this.clientNames?.selected);
  }

  // Access policy for Support Dashboard: only NHA company.
  private canAccessSupportDashboard(): boolean {
    return this.isNhaCompany();
  }

  // Guard entry to Support Dashboard routes.
  // If user/client context is not allowed, redirect them back to home.
  enforceSupportDashboardAccess(): void {
    const currentUrl = this.router.url || "";
    if (
      this.isSupportDashboardRoute(currentUrl) &&
      !this.canAccessSupportDashboard()
    ) {
      this.router.navigate(["/dash/home"]);
    }
  }

  // Centralized matcher for routes that are part of Support Dashboard access policy.
  private isSupportDashboardRoute(url: string): boolean {
    return (
      url.startsWith("/dash/dashboard")
    );
  }

  selectedResourceGroupDisplay: string;
  toggleResourceGroup(rg: any, checked: boolean): void {
    rg.selected = checked;
    this.resourceGroups = [...this.resourceGroups];
    localStorage.setItem("resourceGroupsAccountId", localStorage.getItem("accountId") || "");
    localStorage.setItem("resourceGroups", JSON.stringify(this.resourceGroups));
  }

  hideAzureResourceGroupsSection(): boolean {
    const url = this.currentPageLink || this.router.url || "";
    return (
      url.startsWith("/dash/dashboard") ||
      url.startsWith("/dash/azure/billing") ||
      url.startsWith("/dash/azure/wafr") ||
      url.startsWith("/dash/ticket/list") ||
      url.startsWith("/dash/ticket/create") ||
      url.startsWith("/dash/knowledgebase") ||
      url.startsWith("/dash/settings/audittrail") ||
      url.startsWith("/dash/settings/profile") ||
      // url.startsWith("/dash/feedback") || // FeatureXpress (Feedback) disabled
      url.startsWith("/dash/site24x7/monitors") ||
      url.startsWith("/dash/sla") ||
      url.startsWith("/dash/azure/tell-me") ||
      url.startsWith("/dash/azure/alerts") ||
      url.startsWith("/dash/costopt/azure-ri-recommendations") ||
      url.startsWith("/dash/costopt/azure-savings-plan-recommendations")
    );
  }

  // ─── Navigation helpers ───────────────────────────────────────────────────────

  /**
   * Used by the UI — wraps selectAccountGroup legacy call.
   */
  async selectAccountGroup(accountGroup: any): Promise<void> {
    this.accountGroups.selected = accountGroup.groupName;
    await this.setAccountGroup(this.accountGroups.selected);
  }

  async selectclientName(clientName: any): Promise<void> {
    this.clientNames.selected = clientName.cmpName;
    localStorage.setItem("selectedClientName", this.clientNames.selected);
    localStorage.setItem(
      "selectedClientNameData",
      JSON.stringify(this.clientNames)
    );
    await this.setClientList(clientName.emailId);
  }

  navigateWithReload(targetUrl: string): void {
    const currentUrl = this.router.url;
    if (currentUrl === targetUrl) {
      this.router
        .navigateByUrl("/", { skipLocationChange: true })
        .then(() => this.router.navigateByUrl(targetUrl));
    } else {
      this.router.navigateByUrl(targetUrl);
    }
  }

  async navigateTo(param: any): Promise<void> {
    this.searchValue = "";
    this.router.navigateByUrl(param.url);
  }

  goTO(link: string): void {
    this.showSearchResult = false;
    this.router.navigateByUrl(link);
  }

  // ─── Greengame ────────────────────────────────────────────────────────────────

  // async greengame(monthYear?: Date): Promise<void> {
  //   if (this.getCurrentAccount()["cft_status"]) {
  //     await this.loadJobs(monthYear);
  //     if (this.jobCurrentStatus == "Scanning") {
  //       this.checkProgress(monthYear);
  //     }
  //   } else {
  //     this.jobs = [];
  //   }
  // }

  // greengameroute(): void {
  //   this.router.navigate(["/dash/green-game"]);
  // }

  // async loadJobs(monthY?: Date): Promise<void> {
  //   this.loading["jobs"] = true;
  //   this.accId = localStorage.getItem("accountId");
  //   const monthYear: any = monthY
  //     ? monthY
  //     : moment().startOf("month").format("MM-YYYY");
  //   this.page = 1;

  //   const data: any = {
  //     action: "fetch",
  //     accId: this.accId,
  //     clientId: this.eId,
  //     selectedDate: monthYear,
  //   };
  //   const header = { Authorization: localStorage.getItem("t") };
  //   const apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPre}/greengame`;

  //   const result: any = await this.apiServer.postDataPromis(
  //     apiURL,
  //     data,
  //     header
  //   );

  //   if (result.status == "1" || result.s == "1") {
  //     result.scans = result.scans.sort((a: any, b: any) => {
  //       const da: any = new Date(a["scannedOn"]);
  //       const db: any = new Date(b["scannedOn"]);
  //       return Date.parse(db) - Date.parse(da);
  //     });
  //     this.jobs = result.scans;
  //     this.jobs.forEach((job: any) => {
  //       job["scannedOn"] = moment(job["scannedOn"]).format(
  //         "MMM DD, YYYY hh:mm A"
  //       );
  //       job["cm_time"] = moment(job["cm_time"]).format("MMM DD, YYYY hh:mm A");
  //       job["discountPercentage"] = parseFloat(
  //         job["discountPercentage"]
  //       ).toFixed(2);
  //       this.discountPercentage = job.discountPercentage;
  //       this.totalDiscount = job.totalDiscount;
  //       if (!job["name"]) job["name"] = job["job_id"];
  //     });
  //   } else {
  //     this.jobs = [];
  //   }

  //   this.loading["jobs"] = false;
  // }

  // async loadChecks(
  //   accountId: string,
  //   scanId: string,
  //   status: string
  // ): Promise<void> {
  //   this.loading["checks"] = true;
  //   const data: any = { action: "get", accId: accountId, scanId };
  //   const header = { Authorization: localStorage.getItem("t") };
  //   const apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPre}/greengame`;

  //   const result: any = await this.apiServer.postDataPromis(
  //     apiURL,
  //     data,
  //     header
  //   );

  //   this.loading["checks"] = false;
  //   this.checksAcc = [];

  //   if (result.status == "1" || result.s == "1") {
  //     this.notifier.loading(false);
  //     this.checks = result.scans.map((check: any) => {
  //       check["passed"] = Number(check["passed"]);
  //       check["failed"] = Number(check["failed"]);
  //       check["passedPercentageForFailedLevel"] = Number(
  //         check["passedPercentageForFailedLevel"]
  //       );
  //       this.progresspercentage = check.passedPercentageForFailedLevel;
  //       return check;
  //     });
  //     this.jobCurrentStatus = status;
  //   } else {
  //     this.loading["checks"] = true;
  //     this.checks = [];
  //     this.notifier.alert("Info", "", result.error, "info", 5000);
  //   }
  //   this.notifier.loading(false);
  // }

  // async checkProgress(monthYear?: any): Promise<void> {
  //   setTimeout(async () => {
  //     if (this.checkCount > 10) {
  //       this.loading.checks = false;
  //       this.notifier.alert(
  //         "Info",
  //         "",
  //         "Security Scan is taking longer than usual. Please click on the Refresh button after a couple of minutes.",
  //         "info",
  //         -1
  //       );
  //       return;
  //     }
  //     this.checkCount++;
  //     this.checkInterval += 1000;
  //     await this.loadJobs(monthYear);
  //     if (this.jobCurrentStatus == "Scanning") {
  //       this.checkProgress();
  //     } else {
  //       this.loading.checks = false;
  //     }
  //   }, this.checkInterval);
  // }

  // getStarColor(
  //   index: number,
  //   value: number,
  //   result: string,
  //   total: number
  // ): string {
  //   const shouldColor =
  //     index < value || (index == 3 && value == 3 && result == "passed");
  //   if (shouldColor) {
  //     const intensity = 70 - index * 10;
  //     return `hsl(120, 100%, ${intensity}%)`;
  //   }
  //   return "rgb(224, 216, 216)";
  // }

  // ─── Monitor groups ───────────────────────────────────────────────────────────

  async loadMonitorGroups(): Promise<void> {
    const raw = localStorage.getItem("emsConfig");
    if (!raw) return;

    const emsData: any = JSON.parse(raw);
    const data: any = {
      action: "list_monitor_groups",
      id_token: localStorage.getItem("idT"),
      zaaid: emsData["zaid"],
      login_user_name: this.username,
      login_user_email: this.userId,
      origin: "swayam",
    };
    const header = { Authorization: localStorage.getItem("t") };
    const apiURL = `${environment.apiURL}/${this.urlPrefix}/ems/central`;

    const result: any = await this.apiServer.postDataPromis(
      apiURL,
      data,
      header
    );

    if (result.status == "1" || result.s == "1") {
      localStorage.setItem(
        "site24x7MonitorGroups",
        JSON.stringify(result["monitor_groups"])
      );
    }
  }

  get isDevRevEnabled(): boolean {
    return localStorage.getItem("devrev") === "1";
  }

  checkForSwayamEMS(): string {
    return localStorage.getItem("emsConfig");
  }

  // ─── Notifications ────────────────────────────────────────────────────────────

  notirefe(_event: any): void {
    this.loadNotificationCount();
  }

  async loadNotificationCount(): Promise<void> {
    const header = {
      Authorization: "Bearer " + localStorage.getItem("t"),
    };
    const apiURL = `https://apis-eks.swayam.cloud/global_notification/count_notifications/?email_id=${this.userId}&user_type=internal`;
    try {
      const data: any = await this.apiServer.postDataPromis(
        apiURL,
        {},
        header
      );
      const count = data["total_notification_count"];
      if (count >= 100) {
        this.noticount = "99+";
      } else if (count > 0) {
        this.noticount = count;
      } else {
        this.noticount = 0;
      }
    } catch {
      this.noticount = 0;
    }
  }

  viewNotification(_event: any): void {
    this.viewNotificationTrigger = !this.viewNotificationTrigger;
  }

  // ─── CFT link loading ─────────────────────────────────────────────────────────

  async loadAGL(): Promise<void> {
    this.accountGroups = JSON.parse(
      localStorage.getItem("selectedAccountGroupData")
    );
    this.clientNames = JSON.parse(
      localStorage.getItem("selectedClientNameData")
    );
    this.accountIds = JSON.parse(localStorage.getItem("accountIdData"));
    this.selectedRegion = localStorage.getItem("selectedRegion");
  }

  // ─── Account helpers ──────────────────────────────────────────────────────────

  getCurrentAccount(): Account {
    const id = localStorage.getItem("accountId");
    if (!id) return {} as Account;
    return (
      this.accountIds.list.find((a: any) => a.accountId == id) ??
      ({} as Account)
    );
  }

  checkIfAvaForUser(routeName: string): boolean {
    routeName = (routeName || "").trim().toLowerCase();
    if (localStorage.getItem("role") === "Client") {
      const normalizedAccessList = Array.isArray(this.accessList)
        ? this.accessList.map((x: any) => (x || "").toString().trim().toLowerCase())
        : [];
      return (
        normalizedAccessList.length === 0 ||
        normalizedAccessList.indexOf(routeName) > -1
      );
    }
    return true;
  }

  checkForDemoAccount(): boolean {
    return this.clientNames["selected"] == "DemoClient";
  }

  getSelectedAccount(): string {
    return this.checkForDemoAccount()
      ? "1234567890"
      : localStorage.getItem("accountId");
  }

  getSelectedAccountId(): string {
    if (this.checkForDemoAccount()) return "1234567890";
    const id = localStorage.getItem("accountId");
    if (this.selectedCloudPartner == "azure") {
      return "xxxx-xxxx-xxxx-xx" + id.slice(-5);
    }
    return id;
  }

  getSelectedRegion(): string {
    return localStorage.getItem("regionId");
  }

  getMiddleString(text: string): string {
    return text.substring(text.indexOf("(") + 1, text.lastIndexOf(")"));
  }

  searchOnList(data: string, pattern: string): boolean {
    if (!pattern) return true;
    return data.toLowerCase().indexOf(pattern.toLowerCase()) != -1;
  }

  // ─── Logout ───────────────────────────────────────────────────────────────────

  async logout(): Promise<void> {
    this.notifier.loading(true);
    const data = { eId: this.userId, ut: this.urlPrefix };
    const header = { Authorization: localStorage.getItem("t") };
    const apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/users/logout`;

    const result = await this.apiServer.postDataPromis(apiURL, data, header);
    if (result.status == "1" || result.s == "1") {
      this.notifier.alert("Success", "", result.msg, "success", 5000);
    }

    localStorage.clear();
    setTimeout(() => {
      this.router.navigateByUrl("/login");
      this.notifier.loading(false);
    }, 100);
  }

  // ─── UI helpers ───────────────────────────────────────────────────────────────

  hideLeftMenu(): void {
    $(".leftmenu").addClass("leftmenuhidden");
    $(".rightcontent").addClass("leftmenuhidden");
    $("#menuClosebtn").hide();
    $("#menuShowbtn").show();
    this.isMenuCollapsed = true;
  }

  showLeftMenu(): void {
    $(".leftmenu").removeClass("leftmenuhidden");
    $(".rightcontent").removeClass("leftmenuhidden");
    $("#menuClosebtn").show();
    $("#menuShowbtn").hide();
    this.isMenuCollapsed = false;
  }

  expandDropdown(event: any, value: string): void {
    event.stopPropagation();
    this.expanded[value] = !this.expanded[value];
  }

  show(): void {
    this.hideAccountTab = false;
  }

  hidePrompt(_event: any): void {
    this.hideAccountTab = true;
  }

  getPercentage(val?: number): number {
    if (!val) val = 0;
    const r = 12;
    const c = Math.PI * (r * 2);
    val = Math.min(100, Math.max(0, val));
    return ((100 - val) / 100) * c;
  }

  async copyToClipboard(event: any, text: string): Promise<void> {
    event.preventDefault();
    event.stopPropagation();
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(text).catch(() => {});
    }
  }

  async openDevRev() {
  const newTab = window.open('', '_blank');

  try {
    const email = localStorage.getItem('eId');
    const apiURL = `${APIService.API_ENDPOINTV3}/admin/users/devrev_redirection`;
    const result = await this.apiServer.postDataPromis(apiURL, { email });

    const raw: string = result?.redirect_url || result?.link || result?.url;

    // Strip markdown "[text](url)" wrapping if present
    const match = raw?.match(/\((https?:\/\/[^)]+)\)/);
    const url = match ? match[1] : raw;

    if (url && /^https?:\/\//.test(url)) {
      if (newTab) {
        newTab.location.href = url;
      } else {
        window.location.href = url; // popup was blocked, fall back to same tab
      }
    } else {
      newTab?.close();
      this.notifier.alert('Info', '', 'Unable to fetch DevRev link', 'info', 5000);
    }
  } catch (e) {
    console.log(e);
    newTab?.close();
    this.notifier.alert('Info', '', 'Unable to fetch DevRev link', 'info', 5000);
  }
}

  @HostListener("document:click", ["$event"])
  handleOutsideClick(event: MouseEvent): void {
    if (
      this.showMore &&
      this.rgWrapper &&
      !this.rgWrapper.nativeElement.contains(event.target)
    ) {
      this.showMore = false;
    }
  }
}
